import { STORAGE_KEY_OAUTH_DATA } from 'src/data/storage';
import { parseJson } from 'src/lib/common';
import { type MessageData, openPopup, subscribeToMessages } from 'src/lib/popup';
import * as storage from 'src/lib/storage';

interface AuthMessageData extends MessageData {
  data?: AuthData;
}

interface AuthData {
  code?: string;
  errorMessage?: string;
  [key: string]: unknown;
}

const POPUP_OPTIONS = {
  name: 'integration-popup',
  width: 600,
  height: 800,
};

// TODO: check if this can be merged with `openOAuthPopup` from `./utils.ts`
export const openAuthorizeIntegrationPopup = (authUrl: string, popupOptions = {}) =>
  new Promise((resolve, reject) => {
    // The listeners read `popup`, so open it first.
    // Sentry shows a `storage` event that reaches the listener before `window.open` returns.
    const popup = openPopup(authUrl, { ...POPUP_OPTIONS, ...popupOptions });
    if (!popup) {
      reject(new Error('Cannot open pop-up. Redirecting…'));
      return;
    }

    const resultHandler = (authData: AuthData) => {
      popup.close();

      if (!authData) {
        reject();
        return;
      }

      if (authData.errorMessage) {
        reject(new Error(authData.errorMessage));
        return;
      }

      resolve(authData);
    };

    // Listen for message from popup
    const unsubscribeFromMessages = subscribeToMessages(
      (event: AuthMessageData) => {
        if (event.data?.code) {
          unsubscribeFromMessages();
          window.removeEventListener('storage', handleStorageEvent);
          resultHandler(event.data);
        }
      },
      { ...POPUP_OPTIONS, ...popupOptions }
    );

    const handleStorageEvent = (event: StorageEvent) => {
      if (event.key === STORAGE_KEY_OAUTH_DATA) {
        const authData = parseJson(event.newValue || '') as AuthData;
        if (authData) {
          unsubscribeFromMessages();
          window.removeEventListener('storage', handleStorageEvent);
          storage.removeItem(STORAGE_KEY_OAUTH_DATA);
          resultHandler(authData);
        }
      }
    };

    window.addEventListener('storage', handleStorageEvent);

    popup.focus();
  });
